import React from "react";

import "./styles.css";

const Spinner2 = () => {
    return <div className="special-css-loader"></div>;
};

export default Spinner2;
